import React, { useEffect, useState } from 'react'


import styles from '../../css/style.module.css'

import HOC from '../../components/HOC/HOC'
import { Link } from 'react-router-dom';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'
import { getApi } from '../../Repository/Api';


const columns = [
    'S.no',
    'Id',
    'Title',
    'Description',
    'User Name',
    'Creation Date',
    'Status',
];




const AllNotifications = () => {
    const [notificationData, setNotificationData] = useState([])
    const [loading, setLoading] = useState(false);



    const fetchData = async () => {
        await getApi(endPoints.getnotification, {
            setResponse: setNotificationData,
            setLoading,
            errorMsg: 'Failed to fetch faq!'
        });
    };

    useEffect(() => {
        fetchData();
    }, []);



  



    const routeMapping = {
        'Send Notification': "/notification/send",
        'All Notifications': "/notification/all",
    };

    return (
        <>
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>All Notifications</h6>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Send Notification', 'All Notifications'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'All Notifications'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            <img src={img2} alt="Loading" width={100} height={100} />
                                        </td>
                                    </tr>
                                ) : (!notificationData?.data || Object.keys(notificationData.data).length === 0) ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            No data available.
                                        </td>
                                    </tr>
                                ) : (
                                    notificationData?.data?.map((item, rowIndex) => (
                                        <tr key={rowIndex} className={styles.tableRow}>
                                            <td className={styles.tableCell}>{rowIndex + 1}</td>
                                            <td className={styles.tableCell}>{item.id || "N/A"}</td>
                                            <td className={styles.tableCell}>{item.title || "N/A"}</td>
                                            <td className={styles.tableCell}>{item.body || "N/A"}</td>
                                            <td className={styles.tableCell}>{item?.userId?.firstName || "Unknown"} {item?.userId?.lastName || "Unknown"}</td>
                                            <td className={styles.tableCell}>{item.date || "Unknown"}</td>
                                            <td className={styles.tableCell}>{item.status || "Unknown"}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>

            </div >
        </>
    )
}

export default HOC(AllNotifications)
